import { STORAGE_KEYS } from '~constants'

const setMetadata = (metadata: Record<string, string>) => {
  localStorage.setItem(STORAGE_KEYS.CONSULTATION_METADATA, JSON.stringify(metadata))
}

export default setMetadata
